(function () {
  'use strict';

  angular
    .module('configureTrackingColor')
    .config(config);

  function config($stateProvider) {
    $stateProvider
      .state('configureTrackingColor', {
        url: '/configure-tracking-color',
        views : {
        	'trackigColorView':{
		        templateUrl: 'configure-tracking-color/views/configure-tracking-color.tpl.html',
		        controller: 'ConfigureTrackingColorCtrl',
		        controllerAs: 'configureTrackingColor'
        	}
        },
      });
    
  }
}());
